export default __webpack_public_path__ + "static/media/wisdom.5d38b7c2.png";